module.exports = {
    "language": {
        "name": "Русский",
        "code": "ru-RU",
        "codeShort": "ru"
    },
    "common": {
        "acceptAgbText": "Настоящим подтверждаю, что я прочитал <1>Правила и условия</1> и принимаю их.",
        "dataProtection": "Конфиденциальность",
        "imprint": "Импрессум",
        "administration": "Администрация",
        "settings": "Настройки",
        "settingsDesc": "Измените свои настройки",
        "logoAlt": "3m5 Логотип",
        "navLabelExampleForm": "Пример",
        "navDescExampleForm": "Пример описания",
        "profileUpdateSuccessModalText": "Профиль был успешно обновлен. \nПожалуйста, войдите в систему снова",
        "passwordResetSuccessModalText": "Пароль был успешно сброшен. \nПожалуйста, войдите снова",
        "navLabelDashboard": "Панель управления",
        "navDescDashboard": "Главная страница",
        "navLabelBusiness": "Компания",
        "navDescBusiness": "Компания",
        "navLabelUser": "Пользователь",
        "navDescUser": "Пользователь",
        "navLabelInviteColleagues": "Пригласить коллег",
        "navHeaderInviteColleagues": "Пригласите своих коллег в SAF-HOLLAND I.Q. PORTAL",
        "navDescInviteColleagues": "Укажите данные вашего коллеги",
        "navLabelEmpolis": "Knowledge Center",
        "navDescEmpolis": "Все документы на одном экране",
        "navLabelPod": "POD",
        "navDescPod": "Наш магазин запасных частей \"Parts On Demand\"",
        "navLabelServiceReportOnline": "Отчет о сервисе",
        "navDescServiceReportOnline": "Контактная форма для запросов по гарантии",
        "navLabelTrainings": "Обучающие видео",
        "navDescTrainings": "Обучение",
        "navLabelSpareAxleRequest": "Запрос на замену оси",
        "navHeaderSpareAxleRequest": "Запрос на замену оси",
        "navDescSpareAxleRequest": "Быстро и просто достигните цели. Форма для запроса замены оси.",
        "headSpareAxleRequest": "Быстро и просто достигните цели. Форма для запроса замены оси.",
        "register": "Войти",
        "salutation": "Обращение",
        "firstName": "Имя",
        "participatingCompany": "Участвующая компания",
        "courseName": "Название курса",
        "attendeesName": "Имя участника",
        "streetNr": "Улица, №",
        "surname": "Фамилия",
        "eMail": "Адрес электронной почты",
        "street": "Улица",
        "country": "Страна",
        "zip": "Почтовый индекс",
        "city": "Город",
        "phone": "Телефон",
        "phoneNr": "Номер телефона",
        "businessSegment": "Сфера бизнеса",
        "customerNumber": "Номер клиента",
        "ustIdNr": "Идентификационный номер НДС",
        "tryAgain": "Попробовать снова",
        "editAzureProfile": "Редактирование профиля Azure",
        "streetAndNumber": "Улица и номер дома",
        "companyName": "Название компании",
        "vatId": "идентификационный номер НДС",
        "partsOnDemand": "POD",
        "reklamation": "Отчет о сервисе",
        "knowledgePortal": "Knowledge Center",
        "onlineForm": "Онлайн форма",
        "serviceTeam": "Служба поддержки",
        "misterAbbreviation": "Господин",
        "missusAbbreviation": "Женщина",
        "doctorAbbreviation": "Д-р",
        "professorAbbreviation": "Проф.",
        "inviteColleague": "Пригласить коллег",
        "submitInviteInviteColleagueSuccess": "Приглашение коллег успешно выполнено",
        "submitInviteInviteColleagueFailure": "При отправке формы произошла ошибка. Пожалуйста, попробуйте еще раз через несколько минут.",
        "submitInviteInviteColleagueFailure_UserExists": "Пользователь не может быть приглашен, потому что электронный адрес уже используется в системе.",
        "navLabelRegistrationCourse": "Регистрация на очное обучение",
        "navHeaderRegistrationCourse": "Регистрация на очное обучение",
        "axleBody": "Осевой корпус",
        "completeAxle": "Полная ось",
        "completeAggregate": "Полный агрегат",
        "serialNumber": "Серийный номер",
        "axleComponent": "Какой компонент вы хотите заменить?",
        "optionalInfoText": "Дополнительная информация",
        "contactDetails": "Контактные данные",
        "axleDetails": "Данные оси",
        "component": "Компонент",
        "optionalInfo": "Дополнительная информация",
        "navTrainings": "Тренинги",
        "navLabelRegistration": "Регистрация",
        "navDescRegistration": "Регистрация",
        "step1contactDetails": "1. Контактная информация",
        "step2axleDetails": "2. Данные оси",
        "step3Summary": "3. Резюме",
        "submitRegistrationCourseSuccess": "Регистрация успешна",
        "submitRegistrationCourseFailure": "Регистрация не удалась",
        "registrationCourseHeader": "Регистрация на очное обучение",
        "registrationCourseSubHeader": "Введите свои данные",
        "registrationCourseDescription": "Все поля, отмеченные *, являются обязательными и должны быть заполнены перед отправкой. Обучение проводится в соответствии с действующими на данный момент правилами по коронавирусу.",
        "registrationCourseInputLabelCourseName": "Название курса",
        "registrationCourseInputLabelCompanyName": "Участвующая компания",
        "registrationCourseInputLabelStreetNr": "Улица, №",
        "registrationCourseInputLabelZipCity": "Почтовый индекс, город",
        "registrationCourseInputLabelPhoneNr": "Телефон",
        "registrationCourseInputLabelEmail": "Адрес электронной почты",
        "registrationCourseInputLabelAttendeesName": "Участник {{number}} Имя",
        "registrationCourseInputLabelAgbAccepted": "Я принимаю <1>Общие условия участия.</1>",
        "registrationCourseButtonLabelRegister": "Войти",
        "registrationCourseCoronaInfo": "Тренинги проводятся в соответствии с действующими на данный момент правилами в связи с коронавирусом",
        "navLabelAcademy": "Academy",
        "academyPageHeadline": "SAF-HOLLAND ACADEMY",
        "academyText1": "Вы хотите познакомиться с нашей продукцией, обновить свои знания или углубить их. Тогда вы пришли по адресу. В нашем портале SAF-HOLLAND Academy вы найдете не только базовые тренинги по всему нашему продуктовому портфолио, но и специализированные тренинги по специальным продуктам и темам. Будь то онлайн, на вашем месте или в нашей академии SAF-HOLLAND, здесь есть что-то для каждого.",
        "academyText2": "Обучение SAF-HOLLAND охватывает базовые темы в области сервиса и запасных частей для всего ассортимента продукции, а также специализированные темы для определенных продуктов. Наши курсы зарекомендовали себя на практике и предоставляют не только технические знания, но и практический опыт, что представляет реальную ценность для участников.",
        "toAcademy": "Для регистрации",
        "myProfile": "Мой профиль",
        "dashboardPageHeadline": "Добро пожаловать в SAF HOLLAND I.Q. PORTAL",
        "dashboardTextHeadline": "SAF-HOLLAND I.Q. PORTAL: Интеллектуальное качество в один клик.",
        "dashboardText1": "Вы ищете данные, документы или информацию о заказе запасных частей или о рекламации? Здесь вы найдете качество обслуживания на интеллектуальной онлайн-платформе - быстро и индивидуально отфильтрованное с помощью удобного полнотекстового поиска и умного отображения результатов.",
        "dashboardText2": "Просто быстрее достигайте цели. Умная функция поиска в Knowledge Center находит нужную вам тему даже в PDF-документах и изображениях. Таким образом, вы получаете быстрый доступ ко всей технической документации по всем продуктам SAF-HOLLAND и POD.",
        "dashboardText3": "Но и ваши претензии здесь в хороших руках: с помощью нескольких кликов вы можете отправить претензию нашей службе поддержки через онлайн-форму.",
        "serviceReportOnlinePageHeadline": "Отчет о сервисе",
        "serviceReportOnlineTextHeadline": "Передавайте претензии вовремя.",
        "serviceReportOnlineText1": "Вы обнаружили недостаток в поставке товаров или техническую проблему? Мы быстро устраняем все ваши заботы и занимаемся вашей жалобой!",
        "serviceReportOnlineText2": "В отчете об обслуживании вы найдете быструю помощь: просто отметьте свою претензию в предназначенной для этого форме, введите свои контактные данные и отправьте документ прямо и безопасно нашей службе поддержки. Здесь ваш случай будет рассмотрен в кратчайшие сроки, и вы получите обратную связь по вашему случаю ущерба.",
        "serviceReportOnlineImgLabel": "Привет. Я маленький слепой текст. И так давно, как только я могу помнить. Было непросто понять, что значит быть слепым текстом: это не имеет смысла.",
        "startRequest": "Начать запрос",
        "empolisPageHeadline": "Knowledge Center",
        "empolisTextHeadline": "Технические темы быстро найдены.",
        "empolisText1": "Knowledge Center SAF-HOLLAND - это именно та система управления информацией, которая нужна всем, кто хочет получать актуальные знания 24/7. Здесь вы найдете множество документов и новостей по всем группам продуктов и аксессуарам, удобно структурированных в различные информационные форматы. Вы ищете определенное руководство пользователя, хотите углубиться в технологию или найти детали о продукте?",
        "empolisText2": "В Knowledge Center вы можете выбирать между различными группами продуктов и типами информации, тем самым сужая область поиска. Кроме того, вы можете ввести любые ключевые слова или проблемные ситуации в интеллектуальный поиск по полному тексту. Система автоматически направит вас к соответствующему документу или найденному ответу. Определенные вами поисковые термины даже будут выделены в найденном тексте. В меню вы также можете дополнительно настроить свой Knowledge Center, например, установить закладки на интересующие источники, получать новости напрямую или просматривать историю поиска.",
        "empolisImgLabel": "Привет. Я маленький слепой текст. И так давно, как только я могу помнить. Было непросто понять, что значит быть слепым текстом: это не имеет смысла.",
        "toKnowledgePortal": "В Knowledge-Center",
        "partsOnDemandPageHeadline": "POD (Parts On Demand)",
        "partsOnDemandTextHeadline": "Заказывайте запасные части в любое время.",
        "partsOnDemandText1": "Вы ищете конкретную запасную часть для вашего продукта SAF-HOLLAND и хотите быстро сделать правильный заказ? Тогда вы лучше всего доберетесь до цели здесь! В разделе портала POD (Parts On Demand) вы найдете не только подробную информацию обо всех в настоящее время доступных запасных частях, но и сможете сделать свой выбор прямо через платформу для клиентов.",
        "partsOnDemandText2": "Чем быстрее запасная часть становится доступной, тем лучше, потому что простой тормозит ваш бизнес. Мы знаем, насколько важно, чтобы вы быстро восстановили свою мобильность, и оптимизировали нашу логистику запасных частей. Поэтому теперь вы можете напрямую искать необходимую вам деталь в Интернете и заказывать ее через POD. POD также предоставляет вам обзор всех товаров и групп продуктов - здесь вы можете спокойно искать запасные части и находить дополнительную информацию.",
        "partsOnDemandImgLabel": "Привет. Я маленький слепой текст. И так давно, как только я могу помнить. Было непросто понять, что значит быть слепым текстом: это не имеет смысла.",
        "toPodPortal": "На портал POD",
        "trainingsPageHeadline": "Обучающие видео",
        "trainingsTextHeadline1": "Базовый тренинг - Обзор продукта I - Общие сведения и оси",
        "trainingsTextHeadline2": "Базовый тренинг - Обзор продукции II - Дисковые тормоза",
        "trainingsTextHeadline3": "Базовый тренинг - Обзор продукции III - Системы подвески и аксессуары",
        "profileUpdateSuccess": "Профиль был успешно обновлен.\nПожалуйста, войдите снова.",
        "passwordResetSuccess": "Пароль был успешно сброшен.\nПожалуйста, войдите с вашим новым паролем.",
        "infoNetworkProblems1": "Уважаемый клиент, из-за проблем с сетью мы сейчас, к сожалению, очень ограничены в доступности по электронной почте и телефону.\nПожалуйста, свяжитесь со своим представителем по внешним связям, используя мобильный номер.\nЭтот номер телефона вы также найдете на этом веб-сайте под ",
        "infoNetworkProblemsLink": "https://safholland.com/int/ru/",
        "infoNetworkProblems2": "Благодарим за ваше понимание",
        "FLEET": "Флот",
        "VEHICLE_DEALER": "Автодилер",
        "WORKSHOP": "Мастерская",
        "PARTS_DEALER": "Продавец запасных частей",
        "softwarePageHeadline": "Развертывание программного обеспечения",
        "softwareTextHeadline": "Беззаботное скачивание",
        "softwareText1": "В мире цифровых инноваций доступ к качественному программному обеспечению играет решающую роль. На нашем портале I.Q. мы создали специальный раздел, который позволяет вам с минимальными усилиями скачивать и устанавливать первоклассное программное обеспечение. Всего несколько кликов - и перед вами открывается мир мощных приложений.",
        "softwareText2": "Как только вы найдете нужное программное обеспечение, достаточно одного клика, чтобы начать загрузку. Наша система работает эффективно, чтобы гарантировать, что вы быстро получите необходимые файлы, без долгого ожидания.",
        "softwareText3": "Установка так же проста, как и загрузка. Просто следуйте инструкциям на экране, чтобы быстро и без проблем установить программное обеспечение.",
        "toSoftware": "Перейти к программному обеспечению",
        "navLabelSoftware": "Программное обеспечение"
    },
    "form": {
        "submitForm": "Отправить форму",
        "newUserFormStep1Label": "Пользователь",
        "newUserFormStep2Label": "Компания",
        "newUserFormStepSuccessHeading": "Регистрация успешна.",
        "newUserFormStepSuccessText": "Как только вас активирует администратор, вы сможете использовать клиентский портал.",
        "newUserFormStep1Notification": "Эти данные происходят из вашего профиля Azure.",
        "vehicleManufacturer": "Производитель автомобилей",
        "workshop": "Мастерская",
        "partsDealer": "Продавец запчастей",
        "fleetOrDispatchDepartment": "Флот/Экспедиция",
        "salutationSIR": "Сэр",
        "salutationMADAM": "Мадам",
        "salutationDR": "Др",
        "salutationPROF": "Проф",
        "acceptPrivacyPolicyText": "Настоящим подтверждаю, что я прочитал <1>Политику конфиденциальности</1> и принимаю ее.",
        "acceptPrivacyPolicyInfo": "Вы должны принять политику конфиденциальности, чтобы продолжить.",
        "next": "Дальше",
        "back": "Назад",
        "save": "Сохранить",
        "submit": "Отправить",
        "reset": "сбросить",
        "changeName": "Изменить имя",
        "changePassword": "Изменить пароль",
        "spareAxleRequestFormStep1Label": "Контактные данные",
        "spareAxleRequestFormStep2Label": "Данные оси",
        "spareAxleRequestFormStep3Label": "Резюме",
        "spareAxleRequestFormStepSuccessHeading": "Запрос на замену оси успешно отправлен",
        "spareAxleRequestFormStepSuccessText": "Ваш запрос на замену оси был успешно отправлен",
        "spareAxleRequestFormStepSuccessButton": "Задать дополнительный вопрос",
        "linkNeedHelp": "Вам нужна помощь?",
        "close": "Закрыть"
    },
    "error": {
        "unknownErrorHasOccurred": "Произошла неизвестная ошибка",
        "logOutFailed": "Отмена регистрации не удалась",
        "pageNotFound": "Страница не найдена",
        "companyNameNotFound": "Название компании не найдено",
        "appInitFailed": "Приложение не удалось загрузить. Пожалуйста, попробуйте еще раз позже.",
        "inputInvalid": "недопустимый ввод",
        "atLeastOneElementMustBeCreated": "должен быть создан как минимум 1 элемент",
        "theMinimumQuantityIs": "Минимальное количество составляет {{itemCount}}",
        "noOrderHasBeenPlaced": "Заказ не был сделан",
        "passwordsNotIdentical": "Введенные пароли не совпадают",
        "passwordToShort": "Пароль слишком короткий",
        "fileUploadFailed": "Загрузка файла не удалась",
        "statusCode403": "Доступ запрещен",
        "statusCode404": "Сервер недоступен. Пожалуйста, попробуйте еще раз позже.",
        "statusCode501": "Эта функциональность еще не доступна.",
        "mandatoryField": "Обязательное поле",
        "signInError": "Регистрация не удалась. Пожалуйста, попробуйте еще раз через несколько минут.",
        "signOutError": "Отмена регистрации не удалась. Пожалуйста, обратитесь к администратору.",
        "editProfileError": "При обновлении профиля произошла ошибка. Пожалуйста, обратитесь к администратору.",
        "invalidMailAddress": "недействительный адрес электронной почты",
        "fetchUserError": "Произошла ошибка при получении пользовательских данных. Пожалуйста, обратитесь к администратору.",
        "zipErrorMessage": "Почтовый индекс состоит ровно из 5 цифр",
        "emailErrorMessage": "Недействительный адрес электронной почты",
        "phoneErrorMessage": "Недействительный номер телефона",
        "serialNumberErrorMessage": "Серийный номер должен состоять ровно из 11 цифр",
        "cantDelete": "Во время процесса удаления произошла ошибка. Возможно, объект все еще связан с другими объектами.",
        "cantUpdateNotFound": "Данные не удалось сохранить. Возможно, они больше не существуют.",
        "cantUpdate": "Данные не удалось сохранить. Возможно, вы присвоили значение ключевому атрибуту, которое уже существует.",
        "lackingPermission": "Вы не имеете права вносить желаемые изменения."
    },
    "link": {
        "dataProtection": "https://safholland.com/int/en/privacy-policy/#c4160",
        "imprint": "https://safholland.com/int/en/imprint-1",
        "course1": "https://safholland.com/de/en/events/event/advanced-training-course-23-01-2024",
        "course2": "https://safholland.com/de/en/events/event/haldex-ebs-training-06-02-2024",
        "course3": "https://safholland.com/de/en/events/event/system-training-courses-brake-technology-20-02-2024",
        "course4": "https://safholland.com/de/en/events/event/system-training-steering-axles-09-04-2024",
        "course5": "https://safholland.com/de/en/events/event/haldex-ebs-training-23-04-2024",
        "course6": "https://safholland.com/de/en/events/event/advanced-training-course-14-05-2024",
        "course7": "https://safholland.com/de/en/events/event/haldex-ebs-training-04-06-2024",
        "course8": "https://safholland.com/de/en/events/event/haldex-ebs-training-20-08-2024",
        "course9": "https://safholland.com/de/en/events/event/system-training-driven-axle-saf-intra-cd-trak-08-10-2024",
        "courseOverview": "https://safholland.com/de/en/aftersales/trainings",
        "pod": "https://pod.safholland.de/shop/app?forcerestart=true",
        "course10": "https://safholland.com/de/en/events/event/advanced-training-course-15-10-2024",
        "course11": "https://safholland.com/de/en/events/event/haldex-ebs-training-22-10-2024",
        "course12": "https://safholland.com/de/en/events/event/haldex-ebs-training-12-11-2024",
        "course13": "https://safholland.com/de/en/events/event/system-training-courses-brake-technology-26-11-2024"
    },
    "course": {
        "linkToCourse": "Ссылка на обучение",
        "course1": "23.01. Техническое обслуживание (дополнительное обучение) в SAF-HOLLAND Academy Aschaffenburg",
        "course2": "06. - 07.02. Электронная тормозная система (EBS) Академия SAF-HOLLAND в Ашаффенбурге",
        "course3": "20.02. Техника тормозов SAF-HOLLAND Academy Aschaffenburg",
        "course4": "09.04. Академия SAF-HOLLAND в Ашаффенбурге, управляющие оси",
        "course5": "23. - 24.04. Электронная тормозная система (EBS) Профессиональный учебный центр Tuttlingen GmbH",
        "course6": "14.05. Техническое обслуживание (дополнительное обучение) SAF-HOLLAND Academy Aschaffenburg",
        "course7": "04. - 05.06. Электронная тормозная система (EBS) Frank Fahrzeugbau GmbH, Markranstädt",
        "course8": "20. - 21.08. Электронная тормозная система (EBS) Ремесленная палата Мюнстер",
        "course9": "08.10. Приводные оси в SAF-HOLLAND Academy Aschaffenburg",
        "course10": "15.10. Техническое обслуживание (дополнительное обучение) Академия SAF-HOLLAND в Ашаффенбурге",
        "course11": "22. - 23.10. Электронная тормозная система (EBS) Berger Truck Service GmbH, AT-Wörgl",
        "course12": "12.-13.11. Электронная тормозная система (EBS) Академия SAF-HOLLAND в Ашаффенбурге",
        "course13": "26.11. Техника тормозов SAF-HOLLAND Academy Ашаффенбург"
    }
};